import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase, supabaseAdmin } from '../supabaseClient';
import { SYLLABUS } from '../constants/syllabus';
import { TOPICS } from '../constants/topics';


const TERRACOTTA = '#BC6C25';
const DEEP_MOSS  = '#283618';
const PAPER      = '#FCF9F2';
const OLIVE      = '#606C38';
const WHEAT      = '#FEFAE0';

const GlobalStyle = () => (
  <style>{`
    @keyframes maestraPulse {
      0%   { box-shadow: 0 0 0 0px rgba(217,83,79,0.3); }
      70%  { box-shadow: 0 0 0 10px rgba(217,83,79,0); }
      100% { box-shadow: 0 0 0 0px rgba(217,83,79,0); }
    }
    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(10px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes slideDown {
      from { opacity: 0; transform: translateY(-100%); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .maestra-tab-content { animation: fadeUp 0.35s ease both; }
    .maestra-card:hover  { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(40,54,24,0.08) !important; }
    .maestra-card        { transition: transform 0.2s ease, box-shadow 0.2s ease; }
    .lesson-toggle-btn   { transition: all 0.2s ease; }
    .lesson-toggle-btn:hover { opacity: 0.85; }
    button:focus { outline: none; }
    button:focus-visible { outline: 2px solid rgba(188,108,37,0.4); outline-offset: 2px; }
    .nav-tab { background: #fff !important; border: 1px solid #eee !important; color: #777 !important; }
    .nav-tab:focus, .nav-tab:active { background: #fff !important; color: #777 !important; }
    .nav-tab.active { background: #BC6C25 !important; border-color: #BC6C25 !important; color: #fff !important; }
    @media (max-width: 600px) {
      .student-recap-row { flex-direction: column !important; align-items: flex-start !important; gap: 8px !important; }
      .student-recap-actions { flex-wrap: wrap !important; gap: 8px !important; }
      .upcoming-lesson-row { flex-wrap: wrap !important; }
      .upcoming-lesson-actions { width: 100% !important; display: flex !important; justify-content: flex-end !important; padding-top: 8px !important; border-top: 1px solid #f5f5f5 !important; margin-top: 4px !important; }
      .lesson-toggle-wrap { width: 100% !important; }
      .lesson-toggle-wrap > button { flex: 1 !important; text-align: center !important; }
      .focus-card-inner { padding: 20px 16px !important; }
      .row-input-group { flex-direction: column !important; }
      .row-input-group > * { flex: 1 1 100% !important; min-width: 0 !important; width: 100% !important; box-sizing: border-box !important; }
      .password-wrap { width: 100% !important; box-sizing: border-box !important; }
      .password-wrap input { width: 100% !important; box-sizing: border-box !important;}
      .maestra-header { flex-direction: column !important; align-items: flex-start !important; }
.maestra-nav { width: 100% !important; }
.maestra-nav::-webkit-scrollbar { display: none !important; } }
  `}</style>
);

const PAYMENT_OPTIONS = [
  { value: 'unpaid',      label: '⏳ Da pagare' },
  { value: 'paid',        label: '✓ Pagato' },
  { value: 'late_unpaid', label: '⚠️ Canc. tardiva · Da pagare' },
  { value: 'late_paid',   label: '⚠️ Canc. tardiva · Pagata' },
];

const getPaymentValue = (lesson) => {
  if (lesson.late_cancellation) return lesson.paid ? 'late_paid' : 'late_unpaid';
  return lesson.paid ? 'paid' : 'unpaid';
};

const getPaymentSelectStyle = (lesson) => {
  const value = getPaymentValue(lesson);
  const base = { ...(value === 'paid' || value === 'late_paid' ? paidChipStyle : value === 'late_unpaid' ? lateCancellationChipStyle : unpaidChipStyle) };
  return {
    ...base,
    cursor: 'pointer',
    appearance: 'auto',
    padding: '5px 8px',
    maxWidth: '100%',
    ...(value === 'late_paid' ? { border: '1px solid rgba(217,83,79,0.35)' } : {}),
  };
};

const StudentPanel = ({ student, lessons, onEdit, onDeleteLesson, onSetPayment, onAddLesson }) => {    const now      = new Date();
  const upcoming = lessons.filter(l => new Date(l.created_at) > now).sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  const past     = lessons.filter(l => new Date(l.created_at) <= now).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  return (
    <div style={{ padding: '16px 20px', backgroundColor: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '8px 14px', backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #f0f0f0', marginBottom: '16px', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={panelLabel}>EMAIL</span>
          <span style={panelValue}>{student.email}</span>
        </div>
        {student.meeting_link && (
          <>
            <div style={{ width: '1px', height: '14px', backgroundColor: '#eee' }} />
            <a href={student.meeting_link} target="_blank" rel="noreferrer" style={meetLinkStyle}>🎥 Join Classroom</a>
          </>
        )}
        <div style={{ marginLeft: 'auto' }}>
          <button onClick={() => onAddLesson(student)} style={{ fontSize: '0.75rem', padding: '6px 14px', borderRadius: '8px', border: `1.5px solid ${TERRACOTTA}`, color: TERRACOTTA, backgroundColor: 'transparent', cursor: 'pointer', fontWeight: 700, fontFamily: "'Montserrat', sans-serif" }}>
            + Nuova lezione
          </button>
        </div>
      </div>

      {upcoming.length > 0 && (
        <div style={{ marginBottom: '12px' }}>
          <p style={{ ...panelLabel, display: 'block', marginBottom: '8px', color: TERRACOTTA }}>📅 In programma</p>
          {upcoming.map(l => (
            // CHANGE 5: mobile-friendly recap row via className
            <div key={l.id} className="student-recap-row" style={panelLessonRow}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <span style={{ fontSize: '0.75rem', color: TERRACOTTA, fontWeight: 700 }}>
                  {new Date(l.created_at).toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' })}
                  {' · '}{new Date(l.created_at).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone })
                }
                </span>
                <span style={{ fontSize: '0.75rem', color: DEEP_MOSS, marginLeft: '6px' }}>{l.topic_studied}</span>
                {l.personal_notes?.includes('[RESCHEDULE REQ]') && <span style={alertChip}>⚠️ cambio data</span>}
              </div>
              <div className="student-recap-actions" style={{ display: 'flex', gap: '10px', flexShrink: 0 }}>
                <button onClick={() => onEdit(l)} style={editActionBtn}>modifica</button>
                <button onClick={() => onDeleteLesson(l.id)} style={deleteActionBtn}>cancella</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {past.length > 0 && (
        <div>
          <p style={{ ...panelLabel, display: 'block', marginBottom: '8px', color: OLIVE }}>📝 Lezioni passate</p>
          {past.map(l => (
            // CHANGE 5: mobile-friendly recap row via className
            <div key={l.id} className="student-recap-row" style={panelLessonRow}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <span style={lessonDateStyle}>
                  {new Date(l.created_at).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' })}
                </span>
                <span style={{ fontSize: '0.75rem', color: DEEP_MOSS, marginLeft: '6px' }}>{l.topic_studied}</span>
                {l.vocabulary?.length > 0 && (
                  <span style={{ fontSize: '0.75rem', color: '#444', marginLeft: '6px' }}>· {l.vocabulary.length} parole</span>
                )}
              </div>
              <div className="student-recap-actions" style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
              <select
  value={getPaymentValue(l)}
  onChange={(e) => onSetPayment(l, e.target.value)}
  style={getPaymentSelectStyle(l)}
  aria-label="Stato pagamento"
>
  {PAYMENT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
</select>
                <button onClick={() => onEdit(l)} style={editActionBtn}>modifica</button>
                <button onClick={() => onDeleteLesson(l.id)} style={deleteActionBtn}>cancella</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {upcoming.length === 0 && past.length === 0 && (
        <p style={{ ...emptyNote, textAlign: 'center', padding: '16px 0' }}>Nessuna lezione ancora. Clicca "+ Nuova lezione" per iniziare.</p>
      )}
    </div>
  );
};

const MaestraDashboard = () => {
  const [loading,            setLoading]            = useState(true);
  const [message,            setMessage]            = useState('');
  const [allLessons,         setAllLessons]         = useState([]);
  const [students,           setStudents]           = useState([]);
  const [allResources,       setAllResources]       = useState([]);
  const [expandedStudent,    setExpandedStudent]    = useState(null);
  const [activeTab,          setActiveTab]          = useState('dashboard');
  const [lessonSubTab,       setLessonSubTab]       = useState('passata');
  const [masteryData,        setMasteryData]        = useState([]);
  const [studentMeetingLink, setStudentMeetingLink] = useState('');
  const [notifications,      setNotifications]      = useState([]);
  const [studentName,        setStudentName]        = useState('');
  const [studentEmail,       setStudentEmail]       = useState('');
  const [studentPassword,    setStudentPassword]    = useState('');
  const [showPassword,       setShowPassword]       = useState(false);
  const [lessonDate,         setLessonDate]         = useState(new Date());
  const [bookingDateTime,    setBookingDateTime]    = useState(new Date());
  const [editingLessonId,    setEditingLessonId]    = useState(null);
  const [fileQueue,          setFileQueue]          = useState([]);
  const [currentFileEntry,   setCurrentFileEntry]   = useState({ title: '', category: 'Lezione', file: null, note: '' });
  const [lessonData,         setLessonData]         = useState({ student_name: '', topic_studied: '', personal_notes: '', user_id: '' });
  const [newResource,        setNewResource]        = useState({ title: '', category: 'Lezione', user_id: '' });
  const [newWords,           setNewWords]           = useState([]);
  const [currentWord, setCurrentWord] = useState({ original: '', translation: '', example_sentence: '' });
  const [createdStudent,     setCreatedStudent]     = useState(null);
  // CHANGE 3: separate state for progressi tab, starts empty
  const [progressiStudent,   setProgressiStudent]   = useState('');
  // CHANGE 1: confirm modal replaces window.confirm
  const [confirmModal,       setConfirmModal]       = useState(null);

  const [accepting,     setAccepting]     = useState(true);
  const [waitlist,      setWaitlist]      = useState([]);
  const [showWaitlist, setShowWaitlist] = useState(false);


  const location = useLocation();
  const navigate  = useNavigate();
  const [showIdleWarning, setShowIdleWarning] = useState(false);

  useEffect(() => {
    const TIMEOUT_MS = 60 * 60 * 1000;
    const WARNING_MS = 59 * 60 * 1000;
    let warnTimer, logoutTimer;
    const reset = () => {
      clearTimeout(warnTimer);
      clearTimeout(logoutTimer);
      setShowIdleWarning(false);
      warnTimer   = setTimeout(() => setShowIdleWarning(true), WARNING_MS);
      logoutTimer = setTimeout(async () => {
        await supabase.auth.signOut();
        window.location.reload();
      }, TIMEOUT_MS);
    };
    const events = ['mousemove', 'keydown', 'touchstart', 'scroll', 'click'];
    events.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      clearTimeout(warnTimer);
      clearTimeout(logoutTimer);
      events.forEach(e => window.removeEventListener(e, reset));
    };
  }, []); // eslint-disable-line

  // Escape key closes modals
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key !== 'Escape') return;
      if (showIdleWarning) setShowIdleWarning(false);
      if (confirmModal)    setConfirmModal(null);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [showIdleWarning, confirmModal]); // eslint-disable-line

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('reset') === '1') {
      setActiveTab('dashboard');
      setEditingLessonId(null);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      navigate('/portal', { replace: true });
    }
  }, [location.search, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

  const now             = new Date();
  const upcomingLessons = allLessons.filter(l => new Date(l.created_at) > now).sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  const LESSON_BUFFER_MS = 65 * 60 * 1000; // keep today's lesson visible for 65 min after it starts
const todayLesson      = allLessons.find(l => {
  const start = new Date(l.created_at);
  return start.toDateString() === now.toDateString() && now.getTime() < start.getTime() + LESSON_BUFFER_MS;
});  const totalUnpaid     = allLessons.filter(l => new Date(l.created_at) <= now && !l.paid).length;
  const next5Lessons    = upcomingLessons.slice(0, 5);

  const showNotification    = (msg)   => { setMessage(msg); setTimeout(() => setMessage(''), 4000); };
  const addWordToQueue      = (e)     => { e.preventDefault(); if (!currentWord.original) return; setNewWords(prev => [...prev, { ...currentWord }]); setCurrentWord({ original: '', translation: '', example_sentence: '' }); };
  const removeWordFromQueue = (index) => setNewWords(prev => prev.filter((_, i) => i !== index));

  const handleStudentSelect = (e) => {
    const s = students.find(x => x.id === e.target.value);
    setLessonData({ ...lessonData, user_id: e.target.value, student_name: s ? s.full_name : '' });
  };

  const shouldShowVocab = () => {
    if (lessonSubTab === 'prenota') return false;
    const today    = new Date(); today.setHours(0, 0, 0, 0);
    const selected = new Date(lessonDate); selected.setHours(0, 0, 0, 0);
    return selected <= today;
  };

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const [
        { data: lessonsResult,  error: lessonError   },
        { data: profileData,    error: profileError  },
        { data: mastery,        error: masteryError  },
        { data: resourceData,   error: resourceError },
        { data: noteData,       error: noteError     },
      ] = await Promise.all([
        supabase.from('lessons').select('*, vocabulary (*)').order('created_at', { ascending: false }),
        supabase.from('profiles').select('id, full_name, email, meeting_link'),
        supabase.from('student_mastery').select('*'),
        supabase.from('resources').select('*').order('created_at', { ascending: false }),
supabase.from('notifications').select('*').eq('is_read', false).not('message', 'ilike', '%[LEVEL_COMPLETE]%').not('message', 'ilike', '%[TOPIC_COMPLETE]%').order('created_at', { ascending: false }),      ]);
      const { data: settingsData } = await supabase.from('settings').select('accepting_students').eq('id', 'global').single();
if (settingsData) setAccepting(settingsData.accepting_students);

const { data: waitlistData, error: waitlistError } = await supabase
  .from('waitlist')
  .select('*')
  .order('created_at', { ascending: false });

console.log('waitlist data:', waitlistData);
console.log('waitlist error:', waitlistError);
setWaitlist(waitlistData || []);
      if (lessonError)   throw lessonError;
      if (profileError)  throw profileError;
      if (masteryError)  throw masteryError;
      if (resourceError) throw resourceError;
      if (noteError)     throw noteError;
      const sortedStudents = (profileData || []).sort((a, b) => {
        const lastA = (lessonsResult || []).find(l => l.user_id === a.id);
        const lastB = (lessonsResult || []).find(l => l.user_id === b.id);
        return (lastB ? new Date(lastB.created_at).getTime() : 0) - (lastA ? new Date(lastA.created_at).getTime() : 0);
      });
      setAllLessons(lessonsResult || []); setStudents(sortedStudents); setAllResources(resourceData || []); setMasteryData(mastery || []);
      setNotifications((noteData || []).filter(n =>
        !n.message?.startsWith('[REFUSED]') &&
        !n.message?.startsWith('[CONFIRMED]') &&
        !n.message?.startsWith('[MATERIAL]')
      ));
    } catch (error) {
      showNotification(`Errore caricamento: ${error.message}`);
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchAllData(); }, []); // eslint-disable-line

  if (loading) return (
  <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '40px 20px', fontFamily: "'Montserrat', sans-serif", backgroundColor: '#F7F4EF', minHeight: '100vh' }}>
    <style>{`
      @keyframes shimmer {
        0%   { background-position: -800px 0; }
        100% { background-position: 800px 0; }
      }
      .skeleton {
        background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
        background-size: 800px 100%;
        animation: shimmer 1.5s infinite;
        border-radius: 8px;
      }
    `}</style>

    {/* Header skeleton */}
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '36px', flexWrap: 'wrap', gap: '16px' }}>
      <div>
        <div className="skeleton" style={{ width: 180, height: 12, marginBottom: '10px' }} />
        <div className="skeleton" style={{ width: 280, height: 36 }} />
      </div>
      <div style={{ display: 'flex', gap: '6px' }}>
        {[100, 90, 100, 100, 90].map((w, i) => (
          <div key={i} className="skeleton" style={{ width: w, height: 36, borderRadius: '8px' }} />
        ))}
      </div>
    </div>

    {/* Stats row skeleton */}
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', backgroundColor: '#fff', borderRadius: '16px', padding: '20px 12px', marginBottom: '24px', gap: '4px' }}>
      {[1, 2, 3].map(i => (
        <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', flex: 1 }}>
          <div className="skeleton" style={{ width: 40, height: 28 }} />
          <div className="skeleton" style={{ width: 80, height: 10 }} />
        </div>
      ))}
    </div>

    {/* Toggle skeleton */}
    <div className="skeleton" style={{ height: 56, borderRadius: '12px', marginBottom: '20px' }} />

    {/* Today card skeleton */}
    <div style={{ backgroundColor: '#fff', padding: '36px', borderRadius: '20px', border: '1px solid #f0f0f0', borderTop: '4px solid #f0f0f0', marginBottom: '28px' }}>
      <div className="skeleton" style={{ width: 60, height: 20, borderRadius: '20px', marginBottom: '20px' }} />
      <div className="skeleton" style={{ width: '50%', height: 36, marginBottom: '10px' }} />
      <div className="skeleton" style={{ width: 120, height: 14, marginBottom: '24px' }} />
      <div className="skeleton" style={{ width: 140, height: 40, borderRadius: '8px' }} />
    </div>

    {/* Student list skeletons */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {[1, 2, 3, 4].map(i => (
        <div key={i} style={{ backgroundColor: '#fff', borderRadius: '15px', padding: '14px 16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div className="skeleton" style={{ width: 40, height: 40, borderRadius: '50%', flexShrink: 0 }} />
          <div style={{ flex: 1 }}>
            <div className="skeleton" style={{ width: 160, height: 14, marginBottom: '8px' }} />
            <div className="skeleton" style={{ width: 100, height: 10 }} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

  const handleMarkAsRead = async (id) => {
    try {
      const { error } = await supabase.from('notifications').update({ is_read: true }).eq('id', id);
      if (error) throw error;
      fetchAllData();
    } catch (error) { console.error('Error:', error.message); }
  };

  const handleConfirmReschedule = async (notification) => {
    if (!notification.lesson_id || !notification.requested_time) {
      showNotification('⚠️ Nessun orario strutturato trovato. Aggiorna manualmente.');
      return;
    }
    setLoading(true);
    try {
      const newTime = new Date(notification.requested_time);
      const { error: lessonError } = await supabase.from('lessons')
        .update({ created_at: newTime.toISOString(), personal_notes: '[CONFIRMED]' })
        .eq('id', notification.lesson_id);
      if (lessonError) throw lessonError;
      const { error: notifError } = await supabase.from('notifications').update({ is_read: true }).eq('id', notification.id);
      if (notifError) throw notifError;
      const formattedNew = newTime.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })
                         + ' at ' + newTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
      await supabase.from('notifications').insert([{
        user_id:      notification.user_id,
        student_name: notification.student_name,
        message:      `[CONFIRMED] New lesson on your calendar! Tap to view.`,
        lesson_id:    notification.lesson_id,
        is_read:      false,
      }]);
      // CHANGE 6: toast renders message as-is — no prepended emoji in showNotification
      showNotification(`Lezione spostata a ${formattedNew}`);
      fetchAllData();
    } catch (error) {
      showNotification(`Errore: ${error.message}`);
    } finally { setLoading(false); }
  };

  const handleRefuseReschedule = async (notification) => {
    setLoading(true);
    try {
      const { error: refuseError } = await supabase.from('notifications').insert([{
        user_id:      notification.user_id,
        student_name: notification.student_name,
        message:      '[REFUSED] Can\'t make that time. Email me for options.',        lesson_id:    notification.lesson_id,
        is_read:      false,
      }]);
      if (refuseError) throw refuseError;
      const { error: readError } = await supabase.from('notifications').update({ is_read: true }).eq('id', notification.id);
      if (readError) throw readError;
      showNotification('Richiesta rifiutata. Lo studente è stato notificato.');
      fetchAllData();
    } catch (error) {
      showNotification(`Errore: ${error.message}`);
    } finally { setLoading(false); }
  };

  // CHANGE 1: replace window.confirm with styled modal for delete lesson
  const handleDeleteLesson = (id) => {
    setConfirmModal({
      title:   'Cancella lezione',
      message: 'Vuoi cancellare questa lezione? L\'operazione non può essere annullata.',
      onConfirm: async () => {
        setLoading(true);
        try {
          const { error } = await supabase.from('lessons').delete().eq('id', id);
          if (error) throw error;
          showNotification('Cancellata con successo!');
          fetchAllData();
        } catch (error) { showNotification(`Errore: ${error.message}`); } finally { setLoading(false); }
      },
    });
  };

  const handleDeleteStudent = async (studentId, fullName) => {
    setConfirmModal({
      title:   `Elimina ${fullName}`,
      message: `Stai per eliminare definitivamente ${fullName} e tutte le sue lezioni e risorse. Questa operazione non può essere annullata.`,
      onConfirm: async () => {
        setLoading(true);
        try {
          await supabase.from('resources').delete().eq('user_id', studentId);
          const { data: stLessons } = await supabase.from('lessons').select('id').eq('user_id', studentId);
          if (stLessons?.length > 0) {
            await supabase.from('vocabulary').delete().in('lesson_id', stLessons.map(l => l.id));
            await supabase.from('lessons').delete().eq('user_id', studentId);
          }
          const { error } = await supabase.from('profiles').delete().eq('id', studentId);
          if (error) throw error;
          showNotification(`Profilo di ${fullName} eliminato.`);
          setExpandedStudent(null);
          fetchAllData();
        } catch (error) { showNotification(`Errore: ${error.message}`); } finally { setLoading(false); }
      },
    });
  };

  const startEditing = (lesson) => {
    setEditingLessonId(lesson.id);
    setLessonData({ student_name: lesson.student_name, topic_studied: lesson.topic_studied, personal_notes: lesson.personal_notes || '', user_id: lesson.user_id });
    const date = new Date(lesson.created_at);
    setActiveTab('lezione');
    if (date > now) { setLessonSubTab('prenota'); setBookingDateTime(date); }
    else { setLessonSubTab('passata'); setLessonDate(date); setNewWords(lesson.vocabulary.map(v => ({ original: v.word_original, translation: v.word_translation, example_sentence: v.example_sentence }))); }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleAddLessonForStudent = (student) => {
    setLessonData({ student_name: student.full_name, topic_studied: '', personal_notes: '', user_id: student.id });
    setEditingLessonId(null);
    setLessonSubTab('passata');
    setActiveTab('lezione');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getSignedUrl = async (filePath) => {
    const { data, error } = await supabase.storage.from('resources').createSignedUrl(filePath, 60 * 60);
    if (error) { console.error('Signed URL error:', error.message); return null; }
    return data.signedUrl;
  };

  const handleOpenResource = async (filePath) => {
    const url = await getSignedUrl(filePath);
    if (url) window.open(url, '_blank', 'noreferrer');
    else showNotification('⚠️ Impossibile aprire il file. Riprova.');
  };

const handleSetPaymentStatus = async (lesson, value) => {
  const updates = {
    unpaid:      { paid: false, late_cancellation: false },
    paid:        { paid: true,  late_cancellation: false },
    late_unpaid: { paid: false, late_cancellation: true  },
    late_paid:   { paid: true,  late_cancellation: true  },
  }[value];
  if (!updates) return;
  try {
    const { error } = await supabase.from('lessons').update(updates).eq('id', lesson.id);
    if (error) throw error;
    fetchAllData();
  } catch (e) { showNotification(`Errore: ${e.message}`); }
};

  const handleAddResource = async (e) => {
    e.preventDefault();
    if (!newResource.user_id)  { showNotification('Seleziona uno studente.'); return; }
    if (!fileQueue.length)     { showNotification('⚠️ Aggiungi almeno un file alla coda!'); return; }
    setLoading(true);
    try {
      const uploadedTitles = [];
      await Promise.all(fileQueue.map(async (item) => {
        const fileExt  = item.file.name.split('.').pop();
        const fileName = `${Date.now()}-${Math.random().toString(36).substring(7)}.${fileExt}`;
        const filePath = `${newResource.user_id}/${fileName}`;
        const { error: uploadError } = await supabase.storage.from('resources').upload(filePath, item.file);
        if (uploadError) throw uploadError;
        const { error: dbError } = await supabase.from('resources').insert([{
          title:    item.title,
          category: item.category,
          user_id:  newResource.user_id,
          file_url: filePath,
          note:     item.note || null,
        }]);
        if (dbError) throw dbError;
        uploadedTitles.push(item.title);
      }));
      const notifMessage = uploadedTitles.length === 1
    ? `[MATERIAL] "${uploadedTitles[0]}"`
  : `[MATERIAL] ${uploadedTitles.length} new resources added.`;
      const { error: notifError } = await supabase.from('notifications').insert([{
        user_id:      newResource.user_id,
        student_name: students.find(s => s.id === newResource.user_id)?.full_name || '',
        message:      notifMessage,
        is_read:      false,
      }]);
      if (notifError) console.error('Notification error:', notifError.message);
      showNotification(`${uploadedTitles.length === 1 ? 'Materiale caricato' : `${uploadedTitles.length} materiali caricati`} con successo!`);
      setNewResource({ title: '', category: 'Lezione', user_id: '' });
      setFileQueue([]);
      fetchAllData();
    } catch (e) { showNotification(`Errore: ${e.message}`); } finally { setLoading(false); }
  };

  // CHANGE 1: replace window.confirm with styled modal for delete resource
  const handleDeleteResource = (resourceId, filePath) => {
    setConfirmModal({
      title:   'Elimina risorsa',
      message: 'Vuoi eliminare questo file? Lo studente non potrà più accedervi.',
      onConfirm: async () => {
        setLoading(true);
        try {
          const { error: storageError } = await supabase.storage.from('resources').remove([filePath]);
          if (storageError) throw storageError;
          const { error: dbError } = await supabase.from('resources').delete().eq('id', resourceId);
          if (dbError) throw dbError;
          showNotification('File eliminato!');
          fetchAllData();
        } catch (e) { showNotification(`Errore: ${e.message}`); } finally { setLoading(false); }
      },
    });
  };

  const handleCreateStudent = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data: authData, error: authError } = await supabaseAdmin.auth.admin.createUser({ email: studentEmail.toLowerCase().trim(), password: studentPassword, email_confirm: true, user_metadata: { full_name: studentName, meeting_link: studentMeetingLink } });
      if (authError) throw authError;
      if (authData?.user) { const { error: profileError } = await supabase.from('profiles').update({ meeting_link: studentMeetingLink }).eq('id', authData.user.id); if (profileError) throw profileError; }
      setCreatedStudent({ name: studentName, email: studentEmail.toLowerCase().trim(), password: studentPassword });
      setStudentName(''); setStudentEmail(''); setStudentPassword(''); setStudentMeetingLink(''); fetchAllData();
    } catch (e) { showNotification(`Errore: ${e.message}`); } finally { setLoading(false); }
  };

const toggleMastery = async (studentId, topicName) => {
    const existing = masteryData.find(m => m.student_id === studentId && m.topic_name === topicName);
    const student  = students.find(s => s.id === studentId);
    try {
      if (existing) {
        await supabase.from('student_mastery').delete().eq('id', existing.id);
      } else {
await supabase.from('student_mastery').insert([{ student_id: studentId, topic_name: topicName }]);

        // Lightweight per-topic nudge
        await supabase.from('notifications').insert([{
          user_id:      studentId,
          student_name: student?.full_name || '',
message: `[TOPIC_COMPLETE] "${topicName}" - completed.`,
          is_read:      false,
        }]);
        
        // Check if this completes a level
const updatedMastery = [
  ...masteryData.filter(m => m.student_id === studentId).map(m => m.topic_name),
  topicName,
];

        for (const module of SYLLABUS) {
          for (const subLevel of module.subLevels) {
            const allTopics = subLevel.topics || [];
            if (!allTopics.includes(topicName)) continue;
            const allDone = allTopics.every(t => updatedMastery.includes(t));
            if (allDone) {
              // Check we haven't already sent this notification
              const { data: alreadySent } = await supabase
                .from('notifications')
                .select('id')
                .eq('user_id', studentId)
                .ilike('message', `%[LEVEL_COMPLETE]%`)
                .ilike('message', `%${subLevel.level}%`)
                .limit(1);

              if (!alreadySent?.length) {
                await supabase.from('notifications').insert([{
                  user_id:      studentId,
                  student_name: student?.full_name || '',
                message:      `[LEVEL_COMPLETE] 🎉 You completed ${subLevel.level}!`,     
                 is_read:      false,
                }]);
                showNotification(`🎉 ${student?.full_name} completed ${subLevel.level}!`);
              }
            }
          }
        }
      }
      fetchAllData();
        } catch (error) {
      console.error('toggleMastery error:', error);
      showNotification(`Errore curriculum: ${error.message}`);
    }
  };

  const handleAddLesson = async (e) => {
    e.preventDefault(); setLoading(true);
    const finalDate = lessonSubTab === 'prenota' ? bookingDateTime.toISOString() : (() => {
      const d = lessonDate;
      return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0).toISOString();
    })();    try {
      let lessonId = editingLessonId;
      if (editingLessonId) {
        const { error } = await supabase.from('lessons').update({ ...lessonData, created_at: finalDate }).eq('id', editingLessonId);
        if (error) throw error;
        await supabase.from('vocabulary').delete().eq('lesson_id', editingLessonId);
      } else {
        const { data, error } = await supabase.from('lessons').insert([{ ...lessonData, created_at: finalDate }]).select().single();
        if (error) throw error; lessonId = data.id;
        // CHANGE 2: only notify for future lessons, not past ones
        // CHANGE 2: only notify for future lessons, not past ones
        if (new Date(finalDate) > new Date()) {
          await supabase.from('notifications').insert([{
            user_id:      lessonData.user_id,
            student_name: lessonData.student_name,
            message:      `[CONFIRMED] New lesson on your calendar! Tap to view.`,
            lesson_id:    lessonId,
            is_read:      false,
          }]);
        }
      }
      if (newWords.length > 0) await supabase.from('vocabulary').insert(newWords.map(w => ({ lesson_id: lessonId, word_original: w.original, word_translation: w.translation, example_sentence: w.example_sentence || '', topic_slug: w.topic_slug || null })));
      showNotification(editingLessonId ? 'Lezione modificata!' : 'Lezione salvata con successo!');
      setLessonData({ student_name: '', topic_studied: '', personal_notes: '', user_id: '' }); setNewWords([]); setEditingLessonId(null); setLessonDate(new Date()); setBookingDateTime(new Date()); fetchAllData();
    } catch (e) { showNotification(`Errore: ${e.message}`); } finally { setLoading(false); }
  };

  const NAV_TABS = [
    { id: 'dashboard', label: '🏠 Dashboard' },
    { id: 'lezione',   label: '📝 Lezione' },
    { id: 'progressi', label: '📍 Progressi' },
    { id: 'materiali', label: '📚 Materiali' },
    { id: 'studenti',  label: '✏️ Studenti' },
  ];

  return (
    <div style={containerStyle}>
      <GlobalStyle />

      {/* CHANGE 1: Styled confirm modal — replaces window.confirm everywhere */}
      {confirmModal && (
        <div role="dialog" aria-modal="true" aria-label={confirmModal.title} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(40,54,24,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999, padding: '20px' }}>
          <div style={{ backgroundColor: '#fff', borderRadius: '20px', padding: '36px 32px', maxWidth: '380px', width: '100%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.18)', fontFamily: "'Montserrat', sans-serif" }}>
            <div style={{ fontSize: '1.8rem', marginBottom: '14px' }} aria-hidden="true">🗑</div>
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.4rem', fontWeight: 600, color: DEEP_MOSS, margin: '0 0 10px' }}>
              {confirmModal.title}
            </h3>
            <p style={{ fontSize: '0.8rem', color: '#555', lineHeight: '1.6', margin: '0 0 28px' }}>
              {confirmModal.message}
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={() => setConfirmModal(null)}
                style={{ padding: '10px 28px', borderRadius: '8px', border: '1.5px solid #eee', backgroundColor: '#fff', color: '#555', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer', fontFamily: "'Montserrat', sans-serif', letterSpacing: '0.5px" }}
              >
                Annulla
              </button>
              <button
                onClick={() => { confirmModal.onConfirm(); setConfirmModal(null); }}
                style={{ padding: '10px 28px', borderRadius: '8px', border: 'none', backgroundColor: '#d9534f', color: '#fff', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer', fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.5px' }}
              >
                Elimina
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Idle warning modal */}
      {showIdleWarning && (
        <div role="dialog" aria-modal="true" aria-label="Avviso di inattività" style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(40,54,24,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999, padding: '20px' }}>
          <div style={{ backgroundColor: '#fff', borderRadius: '20px', padding: '40px 32px', maxWidth: '360px', width: '100%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '16px' }}>⏰</div>
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.6rem', fontWeight: 600, color: DEEP_MOSS, margin: '0 0 12px' }}>
              Sei ancora lì?
            </h3>
            <p style={{ fontSize: '0.82rem', color: '#444', lineHeight: '1.6', margin: '0 0 28px' }}>
              Sei inattiva da un po'. Per sicurezza, verrai disconnessa tra <strong>1 minuto</strong>.
            </p>
            <button
              onClick={() => setShowIdleWarning(false)}
              style={{ padding: '12px 36px', borderRadius: '8px', border: 'none', backgroundColor: TERRACOTTA, color: '#fff', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', cursor: 'pointer' }}
            >
              Sono ancora qui
            </button>
          </div>
        </div>
      )}

      {/* CHANGE 6: toast — prepend ✅ only when not an error, no double emoji */}
      {message && (
        <div style={toastContainer} role="status" aria-live="polite">
          <div style={toastMessage}>
            {message.startsWith('⚠️') || message.startsWith('Errore') ? '⚠️ ' : '✅ '}
            {message.startsWith('⚠️') ? message.slice(2).trim() : message}
          </div>
        </div>
      )}

      {/* Header */}
      <header className="maestra-header" style={headerStyle}>
  <div>
    <p style={subtitleStyle}>Francesca's Dashboard</p>
    <h2 style={titleStyle}>Benvenuta, <span style={{ color: TERRACOTTA, fontStyle: 'italic' }}>Francesca!</span></h2>
  </div>
  <nav className="maestra-nav" style={navStyle} aria-label="Navigazione principale">
          {NAV_TABS.map(tab => (
            <button key={tab.id}
              className={`nav-tab${activeTab === tab.id ? ' active' : ''}`}
              onClick={() => { setActiveTab(tab.id); if (tab.id !== 'lezione') setEditingLessonId(null); }}
              aria-current={activeTab === tab.id ? 'page' : undefined}
              style={{ ...navTabBtn, ...(activeTab === tab.id ? activeNavTab : {}) }}>
              {tab.label}
              {tab.id === 'dashboard' && notifications.length > 0 && (
                <span style={notifDotStyle}>{notifications.length}</span>
              )}
            </button>
          ))}
        </nav>
      </header>

      {/* DASHBOARD TAB */}
      {activeTab === 'dashboard' && (
        <div className="maestra-tab-content">
          <div style={statsRowStyle} role="region" aria-label="Statistiche rapide">
            <div style={statCardStyle}>
              <span style={statNumberStyle}>{students.length}</span>
              <span style={statLabelStyle}>Studenti attivi</span>
            </div>
            <div style={statDivider} />
            <div style={statCardStyle}>
              <span style={statNumberStyle}>{upcomingLessons.length}</span>
              <span style={statLabelStyle}>In programma</span>
            </div>
            <div style={statDivider} />
            <div style={statCardStyle}>
              <span style={{ ...statNumberStyle, color: totalUnpaid > 0 ? '#d9534f' : OLIVE }}>{totalUnpaid}</span>
              <span style={statLabelStyle}>Da pagare</span>
            </div>
            {!accepting && (
    <>
      <div style={statDivider} />
      <div
        style={{ ...statCardStyle, cursor: 'pointer' }}
onClick={() => setShowWaitlist(v => !v)}
        title="Clicca per vedere la lista"
      >
        <span style={{ ...statNumberStyle, color: TERRACOTTA }}>{waitlist.filter(w => !w.contacted).length}</span>
        <span style={{ ...statLabelStyle, color: TERRACOTTA }}>In attesa ↓</span>
      </div>
    </>
  )}
          </div>

{/* ── Accepting toggle ── */}
<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 20px', backgroundColor: accepting ? '#f0f7ec' : '#fff5f5', borderRadius: '12px', border: `1px solid ${accepting ? 'rgba(96,108,56,0.2)' : 'rgba(217,83,79,0.2)'}`, marginBottom: '20px' }}>
  <div>
    <p style={{ margin: 0, fontSize: '0.78rem', fontWeight: 700, color: accepting ? '#606C38' : '#c53030' }}>
      {accepting ? '✅ Currently accepting new students' : "🔒 Fully booked - lista d'attesa attivata"}
    </p>
    <p style={{ margin: '2px 0 0', fontSize: '0.72rem', color: '#888' }}>
      {accepting ? 'Toggle off to show the waitlist form on your homepage' : `${waitlist.filter(w => !w.contacted).length} people waiting`}
    </p>
  </div>
  <button
    onClick={async () => {
      const newVal = !accepting;
      const { error } = await supabase.from('settings').update({ accepting_students: newVal }).eq('id', 'global');
      if (!error) setAccepting(newVal);
    }}
    style={{ padding: '8px 20px', borderRadius: '20px', border: 'none', backgroundColor: accepting ? '#606C38' : '#d9534f', color: '#fff', fontSize: '0.72rem', fontWeight: 700, cursor: 'pointer', fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.5px' }}
  >
    {accepting ? 'Close bookings' : 'Open bookings'}
  </button>
</div>

{/* ── Waitlist ── */}
{/* ── Waitlist ── */}
{!accepting && showWaitlist && waitlist.length > 0 && (
  <div id="waitlist-section" style={{ marginBottom: '24px', backgroundColor: '#fff', borderRadius: '14px', border: '1px solid rgba(188,108,37,0.1)', overflow: 'hidden' }}>
    <div style={{ padding: '14px 20px', backgroundColor: 'rgba(188,108,37,0.05)', borderBottom: '1px solid rgba(188,108,37,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <p style={{ margin: 0, fontSize: '0.72rem', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', color: TERRACOTTA }}>
        ✉️ Waitlist — {waitlist.filter(w => !w.contacted).length} pending
      </p>
    </div>
    {waitlist.map((entry, idx) => (
      <div key={entry.id} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '12px 20px', borderTop: idx === 0 ? 'none' : '1px solid #f5f5f5', backgroundColor: entry.contacted ? '#fafafa' : '#fff' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ margin: 0, fontSize: '0.82rem', fontWeight: 600, color: entry.contacted ? '#aaa' : DEEP_MOSS }}>
            {entry.name || 'Anonymous'} — <span style={{ fontWeight: 400 }}>{entry.email}</span>
          </p>
          {entry.message && (
            <p style={{ margin: '2px 0 0', fontSize: '0.72rem', color: '#888', fontStyle: 'italic' }}>"{entry.message}"</p>
          )}
          <p style={{ margin: '2px 0 0', fontSize: '0.65rem', color: '#bbb' }}>
            {new Date(entry.created_at).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}
          </p>
        </div>
        <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
          <a
            href={`mailto:${entry.email}?subject=A spot just opened at SayCiao.school!&body=Ciao ${entry.name || 'there'}! A new spot has just opened up for Italian lessons. I'd love to have you — book your trial here: https://sayciao.school%23booking`}
            style={{ fontSize: '0.72rem', padding: '5px 12px', borderRadius: '6px', backgroundColor: TERRACOTTA, color: '#fff', textDecoration: 'none', fontWeight: 700, fontFamily: "'Montserrat', sans-serif", whiteSpace: 'nowrap' }}
          >
            ✉️ Email
          </a>
          <button
            onClick={async () => {
              await supabase.from('waitlist').update({ contacted: true }).eq('id', entry.id);
              setWaitlist(prev => prev.map(w => w.id === entry.id ? { ...w, contacted: true } : w));
            }}
            style={{ fontSize: '0.72rem', padding: '5px 12px', borderRadius: '6px', border: '1px solid #eee', backgroundColor: '#fff', color: entry.contacted ? '#bbb' : '#606C38', fontWeight: 700, cursor: 'pointer', fontFamily: "'Montserrat', sans-serif", whiteSpace: 'nowrap' }}
          >
            {entry.contacted ? '✓ Contacted' : 'Mark contacted'}
          </button>
        </div>
      </div>
    ))}
  </div>
)}



          {notifications.length > 0 && (
            <div style={{ marginBottom: '24px', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
              {notifications.map((n, idx) => {
const isReschedule = n.message?.includes('[RESCHEDULE REQ]') && !!n.requested_time;
const isReview     = n.message?.startsWith('[REVIEW]');
const isWaitlist   = n.message?.startsWith('[WAITLIST]');
console.log('isReview:', isReview, 'message:', n.message?.substring(0, 20));

const icon         = isReschedule ? '📅' : isReview ? '⭐' : isWaitlist ? '📋' :'🔔';
const label        = isReschedule
  ? `Richiesta di spostamento da ${n.student_name}`
  : isReview
  ? `Nuova recensione da ${n.student_name}`
    : isWaitlist
  ? `Nuovo iscritto alla lista d'attesa`
  : `Notifica da ${n.student_name}`;
const cleanMsg = n.message?.replace('[RESCHEDULE REQ] ', '').replace('[REVIEW] ', '').replace('[WAITLIST] ', '') || n.message;
const reviewEntry = isReview ? (() => {
  const nameMatch     = n.message.match(/name: "([^"]+)"/);
  const locationMatch = n.message.match(/location: "([^"]+)"/);
  const tagMatch      = n.message.match(/tag: "([^"]+)"/);
  const textMatch     = n.message.match(/text: "([^"]+)"/);
  return {
    name:     nameMatch?.[1]     || n.student_name,
    location: locationMatch?.[1] || '',
    tag:      tagMatch?.[1]      || '',
    text:     textMatch?.[1]     || '',
  };
})() : null;

const copyReviewToClipboard = () => {
  if (!reviewEntry) return;
  const entry = `  { name: "${reviewEntry.name}", location: "${reviewEntry.location}", tag: "${reviewEntry.tag}", text: "${reviewEntry.text}" },`;
  navigator.clipboard.writeText(entry);
  showNotification('Recensione copiata — incollala nel file REVIEWS in VS Code!');
};


                return (

<div key={n.id} style={{
  display: 'flex', alignItems: 'center', gap: '14px',
  padding: '14px 24px',
  backgroundColor: isReview ? '#606C38' : TERRACOTTA,
  color: '#fff',
  borderBottom: idx < notifications.length - 1 ? '1px solid rgba(255,255,255,0.15)' : 'none',
}}>
  <span style={{ fontSize: '1.1rem', flexShrink: 0 }}>{icon}</span>
  <div style={{ flex: 1 }}>
    <p style={{ margin: 0, fontSize: '0.82rem', fontWeight: 700, color: '#fff' }}>{label}</p>
    {isReview && reviewEntry ? (
      <div style={{ marginTop: '4px' }}>
        <p style={{ margin: 0, fontSize: '0.75rem', color: 'rgba(255,255,255,0.9)', lineHeight: 1.5 }}>
          <strong>{reviewEntry.tag}</strong>{reviewEntry.location ? ` · ${reviewEntry.location}` : ''}
        </p>
        <p style={{ margin: '3px 0 0', fontSize: '0.78rem', color: 'rgba(255,255,255,0.95)', lineHeight: 1.5, fontStyle: 'italic' }}>
          "{reviewEntry.text}"
        </p>
      </div>
    ) : (
      <p style={{ margin: '2px 0 0', fontSize: '0.75rem', color: 'rgba(255,255,255,0.95)', lineHeight: '1.4' }}>
        {cleanMsg}
        {isReschedule && (
          <span style={{ display: 'block', marginTop: '2px', fontWeight: 700 }}>
            📅 {new Date(n.requested_time).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })} at {new Date(n.requested_time).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
          </span>
        )}
      </p>
    )}
  </div>
  <div style={{ display: 'flex', gap: '8px', flexShrink: 0, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
    {isReschedule && (
      <button onClick={() => handleConfirmReschedule(n)}
        style={{ background: 'rgba(255,255,255,0.9)', border: 'none', cursor: 'pointer', color: '#606C38', fontSize: '0.75rem', fontWeight: 700, padding: '6px 12px', borderRadius: '6px', fontFamily: "'Montserrat', sans-serif", whiteSpace: 'nowrap' }}>
        ✓ Conferma
      </button>
    )}
    {isReview && (
      <button onClick={copyReviewToClipboard}
        style={{ background: 'rgba(255,255,255,0.9)', border: 'none', cursor: 'pointer', color: DEEP_MOSS, fontSize: '0.75rem', fontWeight: 700, padding: '6px 12px', borderRadius: '6px', fontFamily: "'Montserrat', sans-serif", whiteSpace: 'nowrap' }}>
        📋 Copy for VS Code
      </button>
    )}
    <button onClick={() => isReschedule ? handleRefuseReschedule(n) : handleMarkAsRead(n.id)}
      style={{ background: 'rgba(255,255,255,0.2)', border: 'none', cursor: 'pointer', color: '#fff', fontSize: '0.75rem', fontWeight: 700, padding: '6px 12px', borderRadius: '6px', fontFamily: "'Montserrat', sans-serif", whiteSpace: 'nowrap' }}>
      {isReschedule ? 'Rifiuta' : '✓ Letto'}
    </button>
  </div>
</div>

                );
              })}
            </div>
          )}

          {todayLesson ? (
            <div style={todayCardStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                <span style={upcomingPillBadge}>✦ Oggi</span>
                <span style={{ fontSize: '0.75rem', backgroundColor: PAPER, color: TERRACOTTA, padding: '3px 12px', borderRadius: '20px', fontWeight: 700 }}>
                  {new Date(todayLesson.created_at).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
              <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(1.5rem, 4vw, 2rem)', fontWeight: 600, fontStyle: 'italic', color: DEEP_MOSS, margin: '0 0 4px', lineHeight: 1.2 }}>
                {todayLesson.topic_studied || 'Lezione da definire'}
              </h3>
              <p style={{ fontSize: '0.8rem', color: TERRACOTTA, margin: '0 0 20px', fontWeight: 600 }}>{todayLesson.student_name}</p>
              {(() => {
                const sp = students.find(s => s.id === todayLesson.user_id);
                return sp?.meeting_link ? (
                  <a href={sp.meeting_link} target="_blank" rel="noreferrer"
                    style={{ display: 'inline-block', padding: '10px 24px', backgroundColor: TERRACOTTA, color: '#fff', textDecoration: 'none', borderRadius: '8px', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1px' }}>
                    🎥 Entra in Aula
                  </a>
                ) : null;
              })()}
            </div>
          ) : (
            <div style={{ ...todayCardStyle, opacity: 1 }}>
              <span style={upcomingPillBadge}>Oggi</span>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.4rem', fontStyle: 'italic', color: DEEP_MOSS, margin: '12px 0 0', opacity: 0.75 }}>Nessuna lezione oggi</p>
            </div>
          )}

          {next5Lessons.length > 0 && (
            <div style={{ marginBottom: '36px' }}>
              <div style={sectionHeaderStyle}>
                <h3 style={sectionTitleLarge}>📅 Prossime Lezioni</h3>
                <span style={sectionCountBadge}>{upcomingLessons.length} totali</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {next5Lessons.map(lesson => {
                  const studentProfile = students.find(s => s.id === lesson.user_id);
                  const hasAlert       = lesson.personal_notes?.includes('[RESCHEDULE REQ]');
                  const ld             = new Date(lesson.created_at);
                  return (
<div key={lesson.id} className="maestra-card upcoming-lesson-row"
                      style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '14px 20px', backgroundColor: '#fff', borderRadius: '14px', border: '1px solid rgba(188,108,37,0.1)', boxShadow: '0 2px 8px rgba(0,0,0,0.02)', borderLeft: hasAlert ? '4px solid #d9534f' : `4px solid ${TERRACOTTA}`, animation: hasAlert ? 'maestraPulse 2s infinite' : 'none' }}>
                      <div style={dateBadgeMaestra}>
                        <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: TERRACOTTA, fontWeight: 700, letterSpacing: '1px' }}>{ld.toLocaleDateString('it-IT', { month: 'short' })}</span>
                        <span style={{ fontSize: '1.3rem', fontWeight: 700, color: DEEP_MOSS, lineHeight: 1 }}>{ld.getDate()}</span>
                        <span style={{ fontSize: '0.75rem', color: TERRACOTTA, fontWeight: 700 }}>{ld.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}</span>
                      </div>
                      <div style={{ flex: 1 }}>
                        <p style={{ margin: '0 0 2px', fontSize: '0.9rem', fontWeight: 600, color: DEEP_MOSS }}>{lesson.student_name}</p>
                        <p style={{ margin: 0, fontSize: '0.75rem', color: '#444' }}>{lesson.topic_studied || 'Argomento da definire'}</p>
                        {hasAlert && <span style={{ fontSize: '0.75rem', color: '#d9534f', fontWeight: 700 }}>⚠️ Richiesta cambio data</span>}
                      </div>
                      <div className="upcoming-lesson-actions" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexShrink: 0 }}>
  {studentProfile?.meeting_link && (
    <a href={studentProfile.meeting_link} target="_blank" rel="noreferrer"
      style={{ fontSize: '0.75rem', color: DEEP_MOSS, border: `1px solid ${DEEP_MOSS}`, padding: '5px 12px', borderRadius: '6px', textDecoration: 'none', fontWeight: 600 }}>
      🎥 Aula
    </a>
  )}
  <button onClick={() => startEditing(lesson)} style={editBtnSmall}>modifica</button>
  <button onClick={() => handleDeleteLesson(lesson.id)} style={{ ...editBtnSmall, color: '#d9534f', borderBottomColor: 'rgba(217,83,79,0.4)' }}>cancella</button>
</div>



                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div>
            <div style={sectionHeaderStyle}>
              <h3 style={sectionTitleLarge}>👩‍🎓 I miei studenti</h3>
              <span style={sectionCountBadge}>{students.length} studenti</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {students.map(student => {
                const studentLessons   = allLessons.filter(l => l.user_id === student.id);
                const studentResources = allResources.filter(r => r.user_id === student.id);
                const pendingRequest   = studentLessons.find(l => l.personal_notes?.includes('[RESCHEDULE REQ]'));
                const isExpanded       = expandedStudent === student.id;
                const upcomingCount    = studentLessons.filter(l => new Date(l.created_at) > now).length;
                const unpaidCount      = studentLessons.filter(l => new Date(l.created_at) <= now && !l.paid).length;
                return (
                  <div key={student.id} style={{ ...rowCardStyle, borderLeft: pendingRequest ? '5px solid #d9534f' : `5px solid ${isExpanded ? TERRACOTTA : '#f0f0f0'}`, animation: pendingRequest ? 'maestraPulse 2s infinite' : 'none' }}>
                    <div style={{ ...rowBarHeader, backgroundColor: isExpanded ? WHEAT : '#fff' }} onClick={() => setExpandedStudent(isExpanded ? null : student.id)} role="button" tabIndex={0} aria-expanded={isExpanded} aria-label={`${student.full_name} — ${isExpanded ? 'Chiudi' : 'Apri'} dettagli`} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setExpandedStudent(isExpanded ? null : student.id); }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0, flex: 1 }}>
  <div style={{ ...avatarStyle, backgroundColor: isExpanded ? TERRACOTTA : PAPER, color: isExpanded ? '#fff' : TERRACOTTA, flexShrink: 0 }}>
    {student.full_name?.charAt(0).toUpperCase()}
  </div>
  <div style={{ minWidth: 0, flex: 1 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      <span style={nameStyle}>{student.full_name}</span>
      {pendingRequest && <span style={alertChipRed}>⚠️ cambio data</span>}
    </div>
    <div style={{ display: 'flex', gap: '8px', marginTop: '3px', alignItems: 'center' }}>
  <span style={{ fontSize: '0.75rem', color: '#aaa' }}>📚 {studentLessons.length}</span>
  {upcomingCount > 0 && <span style={{ fontSize: '0.75rem', color: TERRACOTTA, fontWeight: 600 }}>📅 {upcomingCount}</span>}
  {unpaidCount > 0 && <span style={{ fontSize: '0.75rem', color: '#d9534f', fontWeight: 700 }}>💰 {unpaidCount}</span>}
  {studentResources.length > 0 && <span style={{ fontSize: '0.75rem', color: '#aaa' }}>📎 {studentResources.length}</span>}
</div>
  </div>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
  <button onClick={(e) => { e.stopPropagation(); handleDeleteStudent(student.id, student.full_name); }} aria-label={`Elimina studente ${student.full_name}`} style={{ cursor: 'pointer', fontSize: '0.75rem', opacity: 0.2, background: 'none', border: 'none', padding: 0 }}>🗑</button>
  <span style={{ fontSize: '0.75rem', color: isExpanded ? TERRACOTTA : '#ccc', fontWeight: 700, flexShrink: 0 }}>{isExpanded ? '▲' : '▼'}</span>
</div>


                    </div>
                    {isExpanded && (
<StudentPanel
  student={student} lessons={studentLessons}
  onEdit={startEditing} onDeleteLesson={handleDeleteLesson}
  onSetPayment={handleSetPaymentStatus} onAddLesson={handleAddLessonForStudent}
/>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* LEZIONE TAB */}
      {activeTab === 'lezione' && (
        <div className="maestra-tab-content">
<div className="focus-card-inner" style={focusCardStyle}>
<div className="lesson-toggle-wrap" style={{ display: 'flex', gap: '0', marginBottom: '32px', backgroundColor: '#f5f5f5', borderRadius: '10px', padding: '4px', width: 'fit-content' }}>              <button className="lesson-toggle-btn"
                onClick={() => { setLessonSubTab('passata'); setEditingLessonId(null); }}
                style={{ ...lessonToggleBtn, ...(lessonSubTab === 'passata' ? lessonToggleActive : {}) }}>
                📝 Lezione Passata
              </button>
              <button className="lesson-toggle-btn"
                onClick={() => { setLessonSubTab('prenota'); setEditingLessonId(null); }}
                style={{ ...lessonToggleBtn, ...(lessonSubTab === 'prenota' ? { ...lessonToggleActive, backgroundColor: DEEP_MOSS } : {}) }}>
                📅 Prenota Lezione
              </button>
            </div>

            {lessonSubTab === 'passata' && (
              <>
                <h3 style={sectionTitle}>{editingLessonId ? '✏️ Modifica Lezione' : '📝 Dettagli Lezione'}</h3>
                <form onSubmit={handleAddLesson} style={formStyle}>
                <div className="row-input-group" style={rowInputGroup}>
                <select style={selectStyle} value={lessonData.user_id} onChange={handleStudentSelect} required aria-label="Seleziona studente">
                      <option value="">...</option>
                      {students.map(s => <option key={s.id} value={s.id}>{s.full_name}</option>)}
                    </select>
                    <input
                      type="date"
                      style={inputStyle}
                      aria-label="Data lezione"
                      value={(() => {
                        const d = lessonDate;
                        const pad = n => String(n).padStart(2, '0');
                        return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
                      })()}                      onChange={(e) => {
                        const [y, m, d] = e.target.value.split('-').map(Number);
                        setLessonDate(new Date(y, m - 1, d, 12, 0, 0));
                      }}                      required
                    />
                    <input style={inputStyle} aria-label="Argomento della lezione" placeholder="Argomento" value={lessonData.topic_studied} onChange={(e) => setLessonData({ ...lessonData, topic_studied: e.target.value })} required />
                  </div>
                  {shouldShowVocab() && (
                    <div style={vocabInputSection}>
                      <p style={notesLabel}>Vocabolario:</p>
                      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', flexWrap: 'wrap' }}>
                        <input style={{ ...inputStyle, flex: 1 }} placeholder="Italiano"   value={currentWord.original}          onChange={(e) => setCurrentWord({ ...currentWord, original:          e.target.value })} />
                        <input style={{ ...inputStyle, flex: 1 }} placeholder="Traduzione" value={currentWord.translation}       onChange={(e) => setCurrentWord({ ...currentWord, translation:       e.target.value })} />
                        <input style={{ ...smallInputStyle, flex: 2 }} placeholder="Esempio" value={currentWord.example_sentence} onChange={(e) => setCurrentWord({ ...currentWord, example_sentence: e.target.value })} />
                        <button type="button" onClick={addWordToQueue} style={addWordBtnSmall}>+</button>
                      </div>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
                        {newWords.map((w, i) => (
                          <span key={i} style={wordBadge}>
                          {w.topic_slug && TOPICS.find(t => t.slug === w.topic_slug)?.emoji + ' '}
                          {w.original} → {w.translation}
                          <button type="button" onClick={() => removeWordFromQueue(i)} aria-label={`Rimuovi ${w.original}`} style={{ marginLeft: '8px', cursor: 'pointer', opacity: 0.75, background: 'none', border: 'none', padding: 0, fontSize: 'inherit' }}>✕</button>
                        </span>
                        ))}
                      </div>
                    </div>
                  )}
                  <textarea style={{ ...inputStyle, height: '80px', paddingTop: '10px' }} placeholder="Note..." value={lessonData.personal_notes} onChange={(e) => setLessonData({ ...lessonData, personal_notes: e.target.value })} />
                  <button style={mainButtonStyle} disabled={loading}>{editingLessonId ? 'Aggiorna' : 'Salva Lezione'}</button>
                </form>
              </>
            )}

            {lessonSubTab === 'prenota' && (
              <>
                <h3 style={{ ...sectionTitle, color: DEEP_MOSS }}>{editingLessonId ? '✏️ Modifica Prenotazione' : '📅 Prenota La Prossima Lezione'}</h3>
                <form onSubmit={handleAddLesson} style={formStyle}>
                <div className="row-input-group" style={rowInputGroup}>
                <select style={selectStyle} value={lessonData.user_id} onChange={handleStudentSelect} required aria-label="Seleziona studente">
                      <option value="">...</option>
                      {students.map(s => <option key={s.id} value={s.id}>{s.full_name}</option>)}
                    </select>
                    <input
                      type="datetime-local"
                      style={inputStyle}
                      aria-label="Data e ora lezione"
                      value={(() => {
                        const d = bookingDateTime;
                        const pad = n => String(n).padStart(2, '0');
                        return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
                      })()}
                      onChange={(e) => {
                        const [datePart, timePart] = e.target.value.split('T');
                        const [y, m, d] = datePart.split('-').map(Number);
                        const [h, min] = timePart.split(':').map(Number);
                        setBookingDateTime(new Date(y, m - 1, d, h, min, 0));
                      }}                      required
                    />
                    <input style={inputStyle} aria-label="Argomento della lezione" placeholder="Argomento" value={lessonData.topic_studied} onChange={(e) => setLessonData({ ...lessonData, topic_studied: e.target.value })} required />
                  </div>
                  <textarea style={{ ...inputStyle, height: '80px', paddingTop: '10px' }} placeholder="Note..." value={lessonData.personal_notes} onChange={(e) => setLessonData({ ...lessonData, personal_notes: e.target.value })} />
                  <button style={{ ...mainButtonStyle, backgroundColor: DEEP_MOSS }} disabled={loading}>{editingLessonId ? 'Aggiorna' : 'Conferma Prenotazione'}</button>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      {/* CHANGE 3: PROGRESSI TAB — uses progressiStudent, starts with empty selection */}
      {activeTab === 'progressi' && (
        <div className="maestra-tab-content">
<div className="focus-card-inner" style={focusCardStyle}>
<h3 style={sectionTitle}>📍 Curriculum & Progressi</h3>
            <select
              style={{ ...selectStyle, marginBottom: '30px' }}
              onChange={(e) => setProgressiStudent(e.target.value)}
              value={progressiStudent}
              aria-label="Seleziona studente per i progressi"
            >
              <option value="">...</option>
              {students.map(s => <option key={s.id} value={s.id}>{s.full_name}</option>)}
            </select>
            {progressiStudent && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '25px' }}>
                {SYLLABUS.map((module, mIndex) => {
                  const studentMastery  = masteryData.filter(m => m.student_id === progressiStudent).map(m => m.topic_name);
                  const allModuleTopics = module.subLevels.flatMap(sub => sub.topics);
                  const masteredCount   = allModuleTopics.filter(t => studentMastery.includes(t)).length;
                  const percentage      = Math.round((masteredCount / allModuleTopics.length) * 100);
                  return (
                    <div key={mIndex} style={{ ...progressCardStyle, borderTop: `4px solid ${TERRACOTTA}` }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <h4 style={{ margin: 0, color: DEEP_MOSS }}>{module.moduleTitle}</h4>
                        <span style={{ color: TERRACOTTA, fontWeight: 'bold' }}>{percentage}%</span>
                      </div>
                      <div style={progressBarContainer}><div style={{ ...progressBarFill, width: `${percentage}%` }} /></div>
                      {module.subLevels.map((sub, sIndex) => (
                        <div key={sIndex} style={{ marginTop: '20px' }}>
                          <h5 style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: TERRACOTTA, marginBottom: '10px', letterSpacing: '1px' }}>
                            {sub.level} — <span style={{ fontWeight: 400, textTransform: 'none' }}>{sub.goal}</span>
                          </h5>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            {sub.topics.map(topic => {
                              const isMastered = studentMastery.includes(topic);
                              return (
                                <div key={topic} onClick={() => toggleMastery(progressiStudent, topic)}
                                  role="checkbox" aria-checked={isMastered} tabIndex={0}
                                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleMastery(progressiStudent, topic); }}
                                  style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '6px 10px', cursor: 'pointer', borderRadius: '6px', backgroundColor: isMastered ? WHEAT : 'transparent', transition: '0.2s', fontSize: '0.9rem' }}>
                                  <span>{isMastered ? '✅' : '⬜️'}</span>
                                  <span style={{ color: isMastered ? DEEP_MOSS : '#666', fontWeight: isMastered ? 600 : 400 }}>{topic}</span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}

      {/* MATERIALI TAB */}
      {activeTab === 'materiali' && (
        <div className="maestra-tab-content">
<div className="focus-card-inner" style={focusCardStyle}>
<h3 style={sectionTitle}>📚 Carica Materiale Didattico</h3>
            <form onSubmit={handleAddResource} style={formStyle}>
              <select
                style={{ ...selectStyle, flex: '0 0 auto', width: 'fit-content', minWidth: '160px', maxWidth: '240px', fontSize: '0.78rem', padding: '10px 12px' }}
                value={newResource.user_id}
                onChange={(e) => setNewResource({ ...newResource, user_id: e.target.value })}
                required
                aria-label="Seleziona studente per il materiale"
              >
                <option value="">...</option>
                {students.map(s => <option key={s.id} value={s.id}>{s.full_name}</option>)}
              </select>

              <div style={{ backgroundColor: '#fafafa', border: '1px solid #f0f0f0', borderRadius: '12px', padding: '20px' }}>
                <p style={notesLabel}>Aggiungi un file alla coda</p>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
                  <input
                    style={{ ...inputStyle, flex: 2 }}
                    placeholder="Titolo"
                    value={currentFileEntry.title}
                    onChange={(e) => setCurrentFileEntry(prev => ({ ...prev, title: e.target.value }))}
                  />
                  {/* CHANGE 4: added Audio option */}
                  <select
                    style={{ ...selectStyle, flex: '0 0 180px' }}
                    value={currentFileEntry.category}
                    onChange={(e) => setCurrentFileEntry(prev => ({ ...prev, category: e.target.value }))}
                    aria-label="Categoria del file"
                  >
                    <option value="Lezione">📖 Lezione</option>
                    <option value="Homework">✍️ Homework</option>
                    <option value="Documenti Extra">📁 Documenti Extra</option>
                    <option value="Audio">🎧 Audio</option>
                  </select>
                </div>

<textarea
  style={{ 
    width: '100%', 
    padding: '12px 14px', 
    borderRadius: '10px', 
    border: '1px solid #eee', 
    fontSize: '0.9rem', 
    outline: 'none', 
    backgroundColor: '#fff',
    height: '44px', 
    resize: 'none', 
    lineHeight: '1.4',
    marginBottom: '12px',
    boxSizing: 'border-box',
    fontFamily: "'Montserrat', sans-serif",
  }}
  placeholder="📌 Note for student (optional) — e.g. study pag 34 ex 5"
  value={currentFileEntry.note}
  onChange={(e) => setCurrentFileEntry(prev => ({ ...prev, note: e.target.value }))}
/>

                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <label style={{ ...fileDropZoneStyle, flex: 1, padding: '14px', margin: 0 }} aria-label="Scegli un file da caricare">
                    <input
                      type="file"
                      style={{ display: 'none' }}
                      onChange={(e) => setCurrentFileEntry(prev => ({ ...prev, file: e.target.files[0] }))}
                    />
                    <span style={{ fontSize: '0.75rem', color: currentFileEntry.file ? TERRACOTTA : '#aaa', fontWeight: 600 }}>
                      {currentFileEntry.file ? `📎 ${currentFileEntry.file.name}` : '📎 Scegli un file'}
                    </span>
                  </label>
                  <button
                    type="button"
                    disabled={!currentFileEntry.file || !currentFileEntry.title}
                    onClick={() => {
                      setFileQueue(prev => [...prev, { ...currentFileEntry }]);
                      setCurrentFileEntry({ title: '', category: 'Lezione', file: null, note: '' });
                    }}
                    style={{ ...mainButtonStyle, padding: '14px 20px', opacity: (!currentFileEntry.file || !currentFileEntry.title) ? 0.4 : 1, whiteSpace: 'nowrap' }}
                  >
                    + Aggiungi
                  </button>
                </div>
              </div>

              {fileQueue.length > 0 && (
                <div style={{ borderRadius: '12px', border: '1px solid rgba(188,108,37,0.15)', overflow: 'hidden' }}>
                  <div style={{ padding: '10px 16px', backgroundColor: 'rgba(188,108,37,0.06)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.75rem', fontWeight: 700, color: TERRACOTTA, letterSpacing: '1px', textTransform: 'uppercase' }}>
                      {fileQueue.length} {fileQueue.length === 1 ? 'file in coda' : 'file in coda'}
                    </span>
                    <button type="button" onClick={() => setFileQueue([])} style={{ background: 'none', border: 'none', fontSize: '0.75rem', color: '#d9534f', cursor: 'pointer', fontWeight: 700 }}>
                      Svuota
                    </button>
                  </div>
                  {fileQueue.map((item, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 16px', backgroundColor: '#fff', borderTop: i > 0 ? '1px solid #f5f5f5' : 'none' }}>
                      {/* CHANGE 4: show 🎧 for Audio category */}
                      <span style={{ fontSize: '1rem' }}>{item.category === 'Audio' ? '🎧' : item.category === 'Video' ? '📽️' : '📄'}</span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ margin: 0, fontSize: '0.78rem', fontWeight: 600, color: DEEP_MOSS }}>{item.title}</p>
                        <p style={{ margin: 0, fontSize: '0.75rem', color: '#444' }}>{item.category} · {item.file.name}</p>
                      </div>
                      <button
                        type="button"
                        onClick={() => setFileQueue(prev => prev.filter((_, idx) => idx !== i))}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#d9534f', fontSize: '0.75rem', fontWeight: 700 }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}

              <button
                style={{ ...mainButtonStyle, opacity: (!fileQueue.length || !newResource.user_id) ? 0.4 : 1 }}
                disabled={loading || !fileQueue.length || !newResource.user_id}
              >
                {loading ? 'Caricamento in corso...' : fileQueue.length > 1 ? `Carica ${fileQueue.length} Materiali` : 'Carica Materiale'}
              </button>
            </form>

            {allResources.length > 0 && (
              <div style={{ marginTop: '36px', paddingTop: '28px', borderTop: '1px solid #f0f0f0' }}>
                <div style={{ ...sectionHeaderStyle, marginBottom: '16px' }}>
                  <h4 style={sectionTitleLarge}>📁 Materiali caricati</h4>
                  <span style={sectionCountBadge}>{allResources.length} file</span>
                </div>
                {allResources.some(r => (Date.now() - new Date(r.created_at).getTime()) / (1000 * 60 * 60 * 24) >= 4) && (
                  <div style={{ marginBottom: '16px', padding: '12px 16px', backgroundColor: '#fff5f5', borderRadius: '10px', border: '1px solid rgba(217,83,79,0.25)', display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span style={{ fontSize: '1rem', flexShrink: 0 }}>🔴</span>
                    <p style={{ margin: 0, fontSize: '0.78rem', color: '#c53030', fontWeight: 600 }}>
                      Alcuni file scadono presto — ricordati di eliminarli o rinnovarli!
                    </p>
                  </div>
                )}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {allResources.map(res => {
                    const daysOld    = (Date.now() - new Date(res.created_at).getTime()) / (1000 * 60 * 60 * 24);
                    const daysLeft   = Math.max(0, Math.ceil(7 - daysOld));
                    const isUrgent   = daysLeft <= 3;
                    const isCritical = daysLeft <= 1;
                    const owner      = students.find(s => s.id === res.user_id);
                    return (
                      <div key={res.id} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '12px 16px', backgroundColor: isCritical ? '#fff9f9' : '#fafafa', borderRadius: '10px', border: `1px solid ${isCritical ? 'rgba(217,83,79,0.25)' : isUrgent ? 'rgba(188,108,37,0.25)' : '#f0f0f0'}` }}>
                        {/* CHANGE 4: show 🎧 for Audio in resource list */}
                        <span style={{ fontSize: '1.2rem', flexShrink: 0 }}>{res.category === 'Audio' ? '🎧' : res.category === 'Video' ? '📽️' : '📄'}</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <p style={{ margin: '0 0 2px', fontSize: '0.82rem', fontWeight: 600, color: DEEP_MOSS, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{res.title}</p>
                          {res.note && (
  <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', margin: '4px 0 0', padding: '3px 10px', backgroundColor: 'rgba(188,108,37,0.08)', borderRadius: '20px' }}>
    <span style={{ fontSize: '0.65rem', fontWeight: 700, color: TERRACOTTA, textTransform: 'uppercase', letterSpacing: '1px' }}>Note</span>
    <span style={{ fontSize: '0.72rem', color: DEEP_MOSS, fontStyle: 'italic' }}>{res.note}</span>
  </div>
)}
                          <p style={{ margin: 0, fontSize: '0.75rem', color: '#444' }}>
                            {owner ? owner.full_name : '—'}
                            <span style={{ margin: '0 6px', opacity: 0.7 }}>·</span>
                            {res.category}
                            <span style={{ margin: '0 6px', opacity: 0.7 }}>·</span>
                            {new Date(res.created_at).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' })}
                          </p>
                        </div>
                        <span style={{ fontSize: '0.75rem', fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0, color: isCritical ? '#c53030' : isUrgent ? TERRACOTTA : '#bbb' }}>
                          {isCritical ? '⚠️ scade domani' : isUrgent ? `⏳ ${daysLeft}g rimasti` : `${daysLeft}g`}
                        </span>
                        <button onClick={() => handleOpenResource(res.file_url)} style={{ ...editActionBtn, marginRight: '4px' }}>apri →</button>
                        <button onClick={() => handleDeleteResource(res.id, res.file_url)} style={deleteActionBtn}>elimina</button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* STUDENTI TAB */}
      {activeTab === 'studenti' && (
        <div className="maestra-tab-content">
<div className="focus-card-inner" style={focusCardStyle}>
<h3 style={sectionTitle}>✏️ Nuovo Studente</h3>
            <form onSubmit={handleCreateStudent} style={formStyle} autoComplete="off">
            <div className="row-input-group" style={rowInputGroup}>
            <input style={inputStyle} placeholder="Nome e Cognome" value={studentName} onChange={(e) => setStudentName(e.target.value)} required name="new-student-fullname" autocomplete="off"/>
                <input style={inputStyle} placeholder="Email" value={studentEmail} onChange={(e) => setStudentEmail(e.target.value)} required name="new-student-email" type="text" autoComplete="off"/>
                <div className="password-wrap" style={{ position: 'relative', flex: 1, display: 'flex' }}>
                <input style={{ ...inputStyle, width: '100%', paddingRight: '50px' }} type={showPassword ? 'text' : 'password'} placeholder="Password" value={studentPassword} onChange={(e) => setStudentPassword(e.target.value)} required name="new-student-password" autoComplete="new-password"/>
                  <button type="button" onClick={() => setShowPassword(v => !v)} aria-label={showPassword ? 'Nascondi password' : 'Mostra password'} style={showHideStyle}>{showPassword ? 'HIDE' : 'SHOW'}</button>
                </div>
                <input style={inputStyle} placeholder="Google Meet" value={studentMeetingLink} onChange={(e) => setStudentMeetingLink(e.target.value)} name="new-student-meeting" autoComplete="off"/>
              </div>
              <button style={mainButtonStyle} disabled={loading}>Registra Studente</button>
            </form>

            {createdStudent && (
              <div style={{ marginTop: '28px', padding: '24px', backgroundColor: '#f0f7ec', borderRadius: '14px', border: '1px solid rgba(96,108,56,0.25)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                  <div>
                    <p style={{ margin: 0, fontSize: '0.75rem', fontWeight: 700, color: '#606C38', textTransform: 'uppercase', letterSpacing: '1px' }}>✅ Studente creato!</p>
                    <p style={{ margin: '4px 0 0', fontSize: '0.82rem', color: DEEP_MOSS }}>Condividi queste credenziali con <strong>{createdStudent.name}</strong></p>
                  </div>
                  <button onClick={() => setCreatedStudent(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: '1rem' }}>✕</button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', backgroundColor: '#fff', borderRadius: '10px', padding: '16px', fontFamily: 'monospace', fontSize: '0.85rem', color: DEEP_MOSS }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><strong>URL:</strong> sayciao.school/portal</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><strong>Email:</strong> {createdStudent.email}</span>
                    <button onClick={() => navigator.clipboard.writeText(createdStudent.email)} style={{ background: 'none', border: '1px solid #eee', borderRadius: '4px', padding: '2px 8px', fontSize: '0.65rem', cursor: 'pointer', color: TERRACOTTA, fontFamily: "'Montserrat', sans-serif" }}>copy</button>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span><strong>Password:</strong> {createdStudent.password}</span>
                    <button onClick={() => navigator.clipboard.writeText(createdStudent.password)} style={{ background: 'none', border: '1px solid #eee', borderRadius: '4px', padding: '2px 8px', fontSize: '0.65rem', cursor: 'pointer', color: TERRACOTTA, fontFamily: "'Montserrat', sans-serif" }}>copy</button>
                  </div>
                </div>
                <button
                  onClick={() => {
                    const text = `Ciao ${createdStudent.name}! Here are your SayCiao portal login details:\n\nURL: sayciao.school/portal\nEmail: ${createdStudent.email}\nPassword: ${createdStudent.password}\n\nSee you soon! 🇮🇹`;
                    navigator.clipboard.writeText(text);
                    showNotification('Credenziali copiate negli appunti!');
                  }}
                  style={{ ...mainButtonStyle, marginTop: '14px', backgroundColor: '#606C38', fontSize: '0.72rem' }}
                >
                  📋 Copia tutto da inviare allo studente
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const containerStyle     = { maxWidth: '1100px', margin: '0 auto', padding: '40px 20px', fontFamily: "'Montserrat', sans-serif", backgroundColor: '#F7F4EF', minHeight: '100vh' };
const headerStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '36px', flexWrap: 'wrap', gap: '16px' };

const titleStyle         = { fontSize: '2rem', fontWeight: 300, margin: 0, color: DEEP_MOSS, fontFamily: "'Cormorant Garamond', serif" };
const subtitleStyle      = { margin: '0 0 4px', color: TERRACOTTA, textTransform: 'uppercase', letterSpacing: '2px', fontSize: '0.75rem', fontWeight: 700 };
const navStyle = { display: 'flex', gap: '6px', flexWrap: 'nowrap', overflowX: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' };
const navTabBtn          = { background: '#fff', border: '1px solid #eee', padding: '10px 18px', borderRadius: '8px', fontSize: '0.75rem', color: '#444', cursor: 'pointer', fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 600, whiteSpace: 'nowrap', position: 'relative', transition: 'all 0.2s ease', outline: 'none' };
const activeNavTab       = { backgroundColor: TERRACOTTA, color: '#fff', fontWeight: 700, border: `1px solid ${TERRACOTTA}`, outline: 'none' };
const notifDotStyle      = { position: 'absolute', top: '6px', right: '6px', width: '18px', height: '18px', backgroundColor: '#d9534f', color: '#fff', borderRadius: '50%', fontSize: '0.6rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 };
const statsRowStyle = { display: 'flex', alignItems: 'center', justifyContent: 'space-around', backgroundColor: '#fff', borderRadius: '16px', padding: '20px 12px', border: '1px solid rgba(188,108,37,0.08)', boxShadow: '0 2px 12px rgba(40,54,24,0.03)', marginBottom: '24px', gap: '4px' };
const statCardStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 8px', flex: 1, minWidth: 0 };
const statDivider        = { width: '1px', height: '40px', backgroundColor: 'rgba(188,108,37,0.1)', flexShrink: 0, alignSelf: 'center' };
const statNumberStyle = { fontSize: '1.4rem', fontWeight: 700, color: DEEP_MOSS, lineHeight: 1, fontFamily: "'Cormorant Garamond', serif" };
const statLabelStyle = { fontSize: '0.6rem', textTransform: 'uppercase', letterSpacing: '0.3px', color: '#3d4a2e', marginTop: '6px', fontWeight: 700, textAlign: 'center', whiteSpace: 'normal', lineHeight: 1.3 };
const todayCardStyle     = { backgroundColor: PAPER, padding: 'clamp(24px, 4vw, 36px)', borderRadius: '20px', marginBottom: '28px', boxShadow: '0 4px 24px rgba(40,54,24,0.06)', border: '1px solid rgba(188,108,37,0.15)', borderTop: `4px solid ${TERRACOTTA}` };
const dateBadgeMaestra   = { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: PAPER, padding: '10px 12px', borderRadius: '10px', minWidth: '52px', flexShrink: 0 };
const sectionHeaderStyle = { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' };
const sectionTitleLarge  = { fontSize: '0.75rem', fontWeight: 700, color: DEEP_MOSS, margin: 0, textTransform: 'uppercase', letterSpacing: '2.5px' };
const sectionCountBadge  = { fontSize: '0.75rem', backgroundColor: 'rgba(40,54,24,0.08)', color: DEEP_MOSS, padding: '3px 8px', borderRadius: '20px', fontWeight: 700 };
const focusCardStyle     = { backgroundColor: '#fff', padding: '36px', borderRadius: '20px', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid rgba(188,108,37,0.08)', marginBottom: '20px' };
const lessonToggleBtn    = { padding: '9px 20px', borderRadius: '8px', border: 'none', background: 'transparent', fontSize: '0.75rem', fontWeight: 600, cursor: 'pointer', fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.5px', color: '#555', whiteSpace: 'nowrap' };
const lessonToggleActive = { backgroundColor: TERRACOTTA, color: '#fff', boxShadow: '0 2px 8px rgba(188,108,37,0.2)' };
const sectionTitle       = { fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '1.5px', color: DEEP_MOSS, marginBottom: '24px', fontWeight: 700 };
const formStyle          = { display: 'flex', flexDirection: 'column', gap: '20px' };
const rowInputGroup      = { display: 'flex', gap: '15px', flexWrap: 'wrap' };
const inputStyle         = { flex: 1, padding: '14px', borderRadius: '10px', border: '1px solid #eee', fontSize: '0.9rem', outline: 'none', backgroundColor: '#fff' };
const selectStyle = { ...inputStyle, flex: '1 1 100%', minWidth: '160px', backgroundColor: '#fff' };
const mainButtonStyle    = { padding: '14px', borderRadius: '10px', border: 'none', backgroundColor: TERRACOTTA, color: '#fff', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', cursor: 'pointer' };
const vocabInputSection  = { backgroundColor: '#fafafa', padding: '20px', borderRadius: '12px', border: '1px solid #f0f0f0' };
const notesLabel         = { fontSize: '0.75rem', textTransform: 'uppercase', color: TERRACOTTA, fontWeight: 700, marginBottom: '10px' };
const smallInputStyle    = { ...inputStyle, padding: '10px' };
const addWordBtnSmall    = { width: '40px', height: '40px', borderRadius: '10px', border: 'none', backgroundColor: DEEP_MOSS, color: '#fff', fontSize: '1.2rem', cursor: 'pointer' };
const wordBadge          = { padding: '6px 12px', backgroundColor: WHEAT, borderRadius: '20px', fontSize: '0.8rem', color: DEEP_MOSS, border: '1px solid rgba(40,54,24,0.1)' };
const fileDropZoneStyle  = { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '30px', borderRadius: '12px', border: '1.5px dashed rgba(188,108,37,0.3)', backgroundColor: '#fafafa', cursor: 'pointer', gap: '4px' };
const showHideStyle      = { position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', fontSize: '0.75rem', color: TERRACOTTA, cursor: 'pointer', fontWeight: 700 };
const toastContainer     = { position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: 10000 };
const toastMessage       = { backgroundColor: DEEP_MOSS, color: '#fff', padding: '12px 25px', borderRadius: '30px', fontSize: '0.85rem', boxShadow: '0 5px 15px rgba(0,0,0,0.2)' };
const rowCardStyle       = { backgroundColor: '#fff', borderRadius: '15px', border: '1px solid #f0f0f0', overflow: 'hidden', transition: 'border-left-color 0.2s ease' };
const rowBarHeader = { padding: '14px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', transition: 'background-color 0.2s ease', gap: '10px' };
const avatarStyle        = { width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', fontWeight: 700, flexShrink: 0, transition: 'all 0.2s ease', border: `1px solid ${WHEAT}` };
const nameStyle          = { fontSize: '0.95rem', fontWeight: 600, color: DEEP_MOSS };
const alertChipRed       = { backgroundColor: '#d9534f', color: '#fff', fontSize: '0.75rem', padding: '2px 6px', borderRadius: '4px', fontWeight: 700 };
const editBtnSmall       = { background: 'none', border: 'none', color: TERRACOTTA, fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer', padding: 0, borderBottom: '1px solid rgba(188,108,37,0.3)', paddingBottom: '1px' };
const progressCardStyle  = { backgroundColor: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 4px 12px rgba(0,0,0,0.03)' };
const progressBarContainer = { width: '100%', height: '6px', backgroundColor: '#eee', borderRadius: '10px', overflow: 'hidden', marginBottom: '20px' };
const progressBarFill    = { height: '100%', backgroundColor: TERRACOTTA, borderRadius: '10px' };
const panelLabel = { fontSize: '0.78rem', letterSpacing: '1.5px', textTransform: 'uppercase', color: '#3d4a2e', fontWeight: 700 };
const panelValue = { fontSize: '0.78rem', color: DEEP_MOSS };
const emptyNote = { fontSize: '0.78rem', color: '#3d4a2e', fontStyle: 'italic', margin: '0 0 4px' };
const upcomingPillBadge  = { display: 'inline-block', fontSize: '0.75rem', letterSpacing: '2px', textTransform: 'uppercase', color: TERRACOTTA, backgroundColor: 'rgba(188,108,37,0.1)', padding: '4px 12px', borderRadius: '20px', fontWeight: 700 };
const panelLessonRow     = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', borderRadius: '8px', backgroundColor: '#fff', border: '1px solid rgba(0,0,0,0.04)', marginBottom: '5px', gap: '10px', flexWrap: 'wrap' };
const lessonDateStyle = { fontSize: '0.78rem', color: '#3d4a2e', fontWeight: 600 };
const editActionBtn      = { background: 'none', border: 'none', fontSize: '0.75rem', color: TERRACOTTA, fontWeight: 700, cursor: 'pointer', padding: 0, textDecoration: 'none', borderBottom: '1px solid rgba(188,108,37,0.4)', paddingBottom: '1px' };
const deleteActionBtn    = { background: 'none', border: 'none', fontSize: '0.75rem', color: '#d9534f', fontWeight: 700, cursor: 'pointer', padding: 0, borderBottom: '1px solid rgba(217,83,79,0.4)', paddingBottom: '1px' };
const meetLinkStyle      = { fontSize: '0.75rem', color: DEEP_MOSS, textDecoration: 'none', fontWeight: 600, border: `1px solid ${DEEP_MOSS}`, padding: '3px 10px', borderRadius: '6px', backgroundColor: '#fff' };
const alertChip          = { fontSize: '0.58rem', color: '#d9534f', fontWeight: 700, marginLeft: '6px' };
const paidChipStyle      = { fontSize: '0.75rem', padding: '4px 10px', borderRadius: '20px', border: 'none', backgroundColor: '#f0f7ec', color: OLIVE, fontWeight: 700, cursor: 'default', fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.5px' };
const unpaidChipStyle    = { fontSize: '0.75rem', padding: '4px 10px', borderRadius: '20px', border: '1px solid rgba(188,108,37,0.3)', backgroundColor: '#FFF8F0', color: TERRACOTTA, fontWeight: 700, cursor: 'pointer', fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.5px' };
const lateCancellationChipStyle = { fontSize: '0.75rem', padding: '4px 10px', borderRadius: '20px', border: '1px solid rgba(217,83,79,0.35)', backgroundColor: '#fff5f5', color: '#c53030', fontWeight: 700, cursor: 'pointer', fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.5px' };

export default MaestraDashboard;